import React, { useEffect, useState } from 'react';
import { FormLabel, TextField, Skeleton, Box } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { useObjectContext } from '@/hooks/useObjectContext';
import { minimalInputTheme } from '@/app/theme';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';

export const DealAmount = () => {
	const { dealRow, dealId } = useObjectContext();

	const [dealAmountValue, setDealAmountValue] = useState(dealRow?.dealAmount ?? 0);

	useEffect(() => {
		setDealAmountValue(dealRow?.dealAmount ?? 0);
	}, [dealRow?.dealAmount]);

	const [updateDealRow, { isLoading: isUpdatingDealRow }] = useUpdateDealRowMutation();
	const updateDealAmount = async () => {
		await updateDealRow({
			dealId: dealRow?.dealId ?? dealId,
			docId: dealRow?.id,
			properties: {
				dealAmount: dealAmountValue,
			},
		}).unwrap();
	};

	return (
		<Box sx={{ width: '100%' }}>
			<FormLabel>Deal amount</FormLabel>
			{isUpdatingDealRow ? (
				<Skeleton animation='wave' width='55%' height='2em' />
			) : (
				<NumericFormat
					fullWidth
					disabled={isUpdatingDealRow}
					customInput={TextField}
					thousandSeparator
					decimalScale={2}
					fixedDecimalScale
					allowNegative={false}
					prefix='$'
					variant='standard'
					sx={minimalInputTheme}
					className='minimal-input'
					value={dealAmountValue ?? ''}
					onValueChange={({ floatValue }) => setDealAmountValue(floatValue ?? null)}
					onBlur={updateDealAmount}
				/>
			)}
		</Box>
	);
};
